import clsx from 'clsx';

/**
 * The match summary ("5 matching accounts · $1.1M opp · ARR $695K · 6 deals", and the renewals line
 * when Renewals is on). `pill` floats in a canvas corner (never intercepts the pointer, sits under
 * menus); `line` is the compact row above the table.
 */
export function HierarchySummary({ lines, variant }: { lines: readonly string[]; variant: 'pill' | 'line' }) {
  if (lines.length === 0) return null;
  return (
    <div
      data-testid="hierarchy-lens-summary"
      className={clsx(
        'flex flex-col text-xs font-medium text-content-primary',
        variant === 'pill'
          ? 'pointer-events-none absolute left-2 top-2 z-[5] gap-0.5 rounded-md border border-border-primary bg-bg-primary px-2 py-1 shadow-sm'
          : 'gap-0.5',
      )}
    >
      {lines.map(line => <span key={line}>{line}</span>)}
    </div>
  );
}
